export const isEmptyDisplayValue = (value: unknown): boolean =>
    value == null || (typeof value === 'string' && value.trim() === '');
